import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFoundPage from "frontend_common/src/components/NotFound";
import Login from "../components/Login";
import store  from '../store'
import i18n from "../i18n";
import IBANInput from "../components/IBANInput";
import NoCertificate from "../components/NoCertificate";
import Registration from "../components/Registration";
import RegistrationConfirmed from "../components/RegistrationConfirmed";
import ConfirmRegistration from "../components/ConfirmRegistration";
import SimpleLayout from "frontend_common/src/layouts/SimpleLayout";
import LegalOwnerInput from "@/components/LegalOwnerInput";

Vue.use(VueRouter);

const links = [
  {
    url: 'http://www.mbills.si/',
    title: 'Domov'
  },
  {
    url: 'http://www.mbills.si/blog',
    title: 'Blog'
  },
  {
    url: 'http://www.mbills.si/pogosta-vprasanja',
    title: 'Pogosta vprašanja'
  },
  {
    url: 'http://www.mbills.si/mediji-o-nas',
    title: 'Mediji o nas'
  },
  {
    url: 'https://www.mbills.si/pogoji-in-cenik',
    title: 'Cenik'
  },
  {
    url: 'http://www.mbills.si/kontakt',
    title: 'Kontakt'
  },
  {
    url: 'http://www.mbills.si/za-podjetja',
    title: 'Za podjetja'
  }
]

const routes = [
  {
    path: "/",
    props: { title: 'Merchant registration portal' },
    redirect: "/home/login",
    name:  i18n.t('routes.home'),
  },
  {
    path: "/noCertificate",
    redirect: "/home/noCertificate",
    name:  i18n.t('routes.noCertificate'),
  },
  {
    path: "/home",
    component: SimpleLayout,
    props: { title: 'Merchant registration portal', links: links },
    redirect: "home/login",
    children: [
      {
        path: "login",
        name: i18n.t('routes.login'),
        component: Login
      },
      {
        path: "IBANInput",
        name: i18n.t('routes.ibanInput'),
        component: IBANInput
      },
      {
        path: "noCertificate",
        name: i18n.t('routes.noCertificate'),
        component: NoCertificate
      },
      {
        path: "registration",
        name: i18n.t('routes.registration'),
        component: Registration
      },
      {
        path: "legalOwnerInput",
        name: i18n.t('routes.legalOwnerInput'),
        component: LegalOwnerInput
      },
      {
        path: "registrationConfirmed",
        name: i18n.t('routes.registrationConfirmed'),
        component: RegistrationConfirmed
      },
      {
        path: "confirmRegistration",
        name: i18n.t('routes.confirmRegistration'),
        component: ConfirmRegistration
      }
    ],
    meta: { loginPage: true, nonRequiresAuth: true }
  },
  { path: "*", component: NotFoundPage }
];

const router = new VueRouter({
  base: 'ip',
  mode: 'hash',
  routes,
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiresAuth = !to.matched.some(record => record.meta.nonRequiresAuth);
  const isLoginPage = to.matched.some(record => record.meta.loginPage);
  if (requiresAuth && !store.state.isAuthenticated) {
    next('/login');
  }
  else if (isLoginPage && store.state.isAuthenticated) {
    next('/');
  }

  next();
});

export default router
